<template>
  <div class="search-input uk-inline"
       :class="{ 'search-input--clearable': allowClear }">
    <span class="uk-form-icon">
      <icon name="search" />
    </span>
    <input ref="primaryInput"
           type="search"
           class="search-input__input uk-input"
           :value="query"
           :placeholder="placeholderOrDefault"
           :disabled="disabled"
           @input="onInput">
    <a v-if="allowClear"
       href="#"
       class="search-input__clear uk-form-icon uk-form-icon-flip"
       @click.prevent="clearAndFocus">
      <icon name="close" />
    </a>
  </div>
</template>

<script>
export default {
  name: 'search-input',
  props: {
    value: String,
    placeholder: String,
    size: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      query: this.value,
    };
  },
  computed: {
    inputCss() {
      return {
        [`uk-form-${this.size}`]: !!this.size,
      };
    },
    placeholderOrDefault() {
      return this.placeholder || this.$t('placeholder');
    },
  },
  watch: {
    value(value) {
      this.query = value;
    },
  },
  methods: {
    onInput(event) {
      let newValue = event.target.value;
      if (!newValue) newValue = null;
      this.query = newValue;
      this.$emit('input', newValue);
      this.$emit('change', newValue);
    },
    focus() {
      this.$refs.primaryInput.focus();
    },
    blur() {
      this.$refs.primaryInput.blur();
    },
    clear() {
      this.query = null;
      this.$emit('input', null);
      this.$emit('change', null);
    },
    clearAndFocus() {
      this.clear();
      this.focus();
    },
  },
  i18n: {
    messages: {
      de: {
        placeholder: 'Suchen…',
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../theme/variables.scss';

.search-input--clearable .search-input__input {
  padding-right: $global-medium-gutter;
}
</style>



// WEBPACK FOOTER //
// SearchInput.vue?4605f45c